import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

import { CfLocales } from '../../modelos/config/config'
import { ConfigService } from '../../servicios/config/config.service'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.scss']
})
export class AgentsComponent implements OnInit {
  public locales: CfLocales[] = [];
  safeSrc: SafeResourceUrl;

  constructor(
    private configService: ConfigService,
    private sanitizer: DomSanitizer,
    public appService: AppService) {
      
      this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15834.68287189876!2d-78.4965395!3d-7.1640123!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf2d5a7ca72d05eb1!2sSAT+Cajamarca!5e0!3m2!1ses-419!2spe!4v1562695001197!5m2!1ses-419!2spe");

     }

  ngOnInit() {

    this.configService.getLocales$().subscribe(
      {
        next: (data) => { this.locales = data },

        error: (err) => { alert('SUCEDIÓ UN ERROR INESPERADO') },

        complete : ()=>{
          this.locales.forEach( element => {

            element.url = this.onUrlMap(element.mapa)
            
          });
        }
      }
    )

  }



  onUrlMap(url: string): SafeResourceUrl {    

    let safeSrc: SafeResourceUrl;    
    safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);    

    return safeSrc
  }

}
